import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import { radarTemplatesAtom } from '@/atoms/queries/userConfigs';
import { ResolvedPositionGroup, resolvePositionGroup } from '@/utils/radar';
import type { UserConfigRadarTemplate } from '@/types/userConfigs';

const unwrappedRadarTemplatesAtom = unwrap(radarTemplatesAtom, prev => prev);

/**
 * The position group the AI summary sends for the selected profile and player, with the positions
 * its in-group minutes are summed over (see resolvePositionGroup). `undefined` while the
 * template or the radar templates are still resolving, so the summary waits for them instead of
 * being requested with a placeholder group.
 */
export const useSummaryPositionGroup = (
  template: UserConfigRadarTemplate | null | undefined,
  primaryPosition: string | undefined,
): ResolvedPositionGroup | undefined => {
  const radarTemplates = useAtomValue(unwrappedRadarTemplatesAtom);

  if (!template || primaryPosition === undefined || !radarTemplates) return undefined;
  return resolvePositionGroup(template, primaryPosition, radarTemplates);
};
